import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';

import getLocale from '../../i18n/getLocale';
import Overlay from '../Miscelania/Overlay';

class StaffDeslocationsEdit extends Component {

    constructor(props) {
        super(props);

        this.state = {
        overlay: {
            message: '',
            type: '',
            status: 'open',
        },
        redirect_url: false,
        loaded: 0,
        id: '',
        date: '',
        deslocation: 0,
        deslocation_time: null,
        staff_deslocations: {},
        };
        //Handlers
        this.handleAlert = this.handleAlert.bind(this);
        this.handleLoaded = this.handleLoaded.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
        this.locale = getLocale();

        this.loadData = this.loadData.bind(this);
        this.edit = this.edit.bind(this);
    }
    // Handlers

    handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
        var value = 1;
        } else {
        var value = 0;
        }
        change[name] = value;
        change['deslocation_time'] = null;
        this.setState(change);
    }

    handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
    }
      
    handleAlert(message, type, status, mode) {
        if(mode === 'reset') {
            this.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
            this.setState({overlay: {message: message, type: type, status: status}});
        }
    }

    handleLoaded(state) {
        if(this.state.loaded !== 2) {
        this.setState({loaded: state});
        }
    }

    handleMessage () {
        var message = localStorage.getItem("verify_message");
        if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
        localStorage.removeItem("verify_message");
        }
    }

    componentDidMount () {
        if(this.state.loaded === 0) {
            this.setState({loaded: 1}, this.loadData());
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.loaded === 1 && prevState.loaded === 0) {
            this.setState({loaded: 2}, this.loadData());
        }
    }

    loadData () {
        var self = this;
        var header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
              
        var url = config.get('api') + '/tripulante/deslocamento/'+self.props.match.params.token;
        fetch(url, { method: 'GET', mode: 'cors', headers: header }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'success') {
                self.setState({
                    id: responseJson.data.main.id,
                    date_str: responseJson.data.main.date_str,
                    staff_deslocations: responseJson.data.staff_deslocations,
                    loaded: true,
                });
                self.setState({overlay: {message: '', type: '', status: 'closed'}});
            } else {
                self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
        }).then(() => {
            self.handleMessage();
        });
    }

    edit(event) {
        event.preventDefault();
        this.handleAlert('', '', 'open');
        var datasave = {
            id: this.state.id,
            deslocation: this.state.deslocation,
            deslocation_time: this.state.deslocation_time,
        };

        var header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
    
        var self = this;
        fetch(config.get('api') + '/tripulante/deslocamento', { method: 'PUT', mode: 'cors', headers: header, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'success') {
            self.setState({ staff_deslocations: responseJson.data });
        } else if(responseJson.data == 'incomplete') {
            self.setState({ loaded: true });
        }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
            console.error(error);
        });
    }
  
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.titulo}</h3>
        <div className="clearfix"></div>
        <hr />
        {this.state.loaded === true ?
            <div>
                <form onSubmit={this.edit}>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.houveDeslocamento + " (" + this.state.date_str + ")"}?</label>
                            <br/>
                            <Toggle
                                checked={this.state.deslocation}
                                aria-label='No label tag'
                                name="deslocation"
                                onChange={this.handleToggleChange.bind(this, 'deslocation')}
                             />
                        </div>
                    </div>
                    {this.state.deslocation ?
                        <div className="row">
                            <div className="col-md-12 form-group">
                                <label>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.tempoDeslocamento}:</label>
                                <InputMask value={this.state.deslocation_time}  maskChar={null} name="deslocation_time " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'deslocation_time')} placeholder="hh:mm" />
                            </div>
                        </div>    
                        : ''
                    }
                    <div>
                        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.botaoSalvar}</button>
                    </div>
                </form>
                <hr />
                <h3 className="page-title">{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tituloAnteriores}</h3>
                <hr />
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped">
                        <thead>
                            <tr>
                                <th>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.dataApresentacao}</th>
                                <th>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.houveDeslocamento}</th>
                                <th>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.tempoDeslocamento}</th>
                                <th>{this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.Status}</th>
                            </tr>
                        </thead>
                        <tbody id="dates">
                            {Object.keys(self.state.staff_deslocations).map(function(k) {
                                var staff_deslocation = self.state.staff_deslocations[k];
                                return (
                                <tr>
                                    <td>{staff_deslocation.date_str}</td>
                                    <td>{staff_deslocation.deslocation_str}</td>
                                    <td>{staff_deslocation.deslocation_time}</td>
                                    <td>{staff_deslocation.status_str}</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        :
            <div className="user-content text-center" style={{paddingTop: '20px', border: 'none'}}>
                <div className="row">
                    <div className="col-md-4 col-md-offset-4 text-center">
                    <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGVOOS" />
                    </div>
                </div>
            </div>
        }
    </div>
  </div>
</div>
    );
  }
}

export default StaffDeslocationsEdit;



// WEBPACK FOOTER //
// ./src/Components/StaffDeslocations/StaffDeslocationsEdit.js